import styled, { css } from 'styled-components';
import { BannerActionPositions, BannerType, BannerVariant } from './types.js';
import { withTheming, Spacing, Breakpoints } from '@doordash/design-language';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getBorderRadiusValue = function getBorderRadiusValue(_ref) {
  var isGlobal = _ref.isGlobal,
      theme = _ref.theme;
  return isGlobal ? theme.BorderRadius.None : theme.BorderRadius.BannerDefault;
};

var getColorSet = function getColorSet(_ref2) {
  var _BannerType$Default, _BannerType$Emphasis, _BannerType$Subdued, _styleConfig;

  var variant = _ref2.variant,
      type = _ref2.type,
      theme = _ref2.theme;
  var BORDER_WIDTH = theme.BorderWidth.Default;
  var BIG_BORDER_WIDTH = 4;
  var styleConfig = (_styleConfig = {}, _defineProperty(_styleConfig, BannerType.Default, (_BannerType$Default = {}, _defineProperty(_BannerType$Default, BannerVariant.Positive, {
    background: theme.Colors.BannerPositiveDefaultBackground
  }), _defineProperty(_BannerType$Default, BannerVariant.Negative, {
    background: theme.Colors.BannerNegativeDefaultBackground
  }), _defineProperty(_BannerType$Default, BannerVariant.Highlight, {
    background: theme.Colors.BannerHighlightDefaultBackground
  }), _defineProperty(_BannerType$Default, BannerVariant.Informational, {
    background: theme.Colors.BannerInformationalDefaultBackground
  }), _defineProperty(_BannerType$Default, BannerVariant.Warning, {
    background: theme.Colors.BannerWarningDefaultBackground
  }), _BannerType$Default)), _defineProperty(_styleConfig, BannerType.Emphasis, (_BannerType$Emphasis = {}, _defineProperty(_BannerType$Emphasis, BannerVariant.Positive, {
    background: theme.Colors.BannerPositiveEmphasisBackground
  }), _defineProperty(_BannerType$Emphasis, BannerVariant.Negative, {
    background: theme.Colors.BannerNegativeEmphasisBackground
  }), _defineProperty(_BannerType$Emphasis, BannerVariant.Highlight, {
    background: theme.Colors.BannerHighlightEmphasisBackground
  }), _defineProperty(_BannerType$Emphasis, BannerVariant.Informational, {
    background: theme.Colors.BannerInformationalEmphasisBackground
  }), _defineProperty(_BannerType$Emphasis, BannerVariant.Warning, {
    background: theme.Colors.BannerWarningEmphasisBackground
  }), _BannerType$Emphasis)), _defineProperty(_styleConfig, BannerType.Subdued, (_BannerType$Subdued = {}, _defineProperty(_BannerType$Subdued, BannerVariant.Positive, {
    background: theme.Colors.BannerPositiveSubduedBackground,
    border: theme.Colors.BannerPositiveSubduedBorder,
    borderLeft: theme.Colors.BannerPositiveSubduedDecorator
  }), _defineProperty(_BannerType$Subdued, BannerVariant.Negative, {
    background: theme.Colors.BannerNegativeSubduedBackground,
    border: theme.Colors.BannerNegativeSubduedBorder,
    borderLeft: theme.Colors.BannerNegativeSubduedDecorator
  }), _defineProperty(_BannerType$Subdued, BannerVariant.Highlight, {
    background: theme.Colors.BannerHighlightSubduedBackground,
    border: theme.Colors.BannerHighlightSubduedBorder,
    borderLeft: theme.Colors.BannerHighlightSubduedDecorator
  }), _defineProperty(_BannerType$Subdued, BannerVariant.Informational, {
    background: theme.Colors.BannerInformationalSubduedBackground,
    border: theme.Colors.BannerInformationalSubduedBorder,
    borderLeft: theme.Colors.BannerInformationalSubduedDecorator
  }), _defineProperty(_BannerType$Subdued, BannerVariant.Warning, {
    background: theme.Colors.BannerWarningSubduedBackground,
    border: theme.Colors.BannerWarningSubduedBorder,
    borderLeft: theme.Colors.BannerWarningSubduedDecorator
  }), _BannerType$Subdued)), _styleConfig);

  if (type === BannerType.Subdued) {
    var subduedStyles = styleConfig.Subdued[variant];
    return css(["background:", ";box-shadow:inset 0 0 0 ", "px ", ";padding:", "px;padding-left:", "px;&::before{width:", "px;display:block;background-color:", ";position:absolute;content:'';left:0px;bottom:-", "px;top:-", "px;}"], subduedStyles.background, BORDER_WIDTH, subduedStyles.border, Spacing.Small + BORDER_WIDTH, Spacing.Small + BIG_BORDER_WIDTH, BIG_BORDER_WIDTH, subduedStyles.borderLeft, BORDER_WIDTH, BORDER_WIDTH);
  }

  var styles = styleConfig[type][variant];
  return css(["background:", ";"], styles.background);
};

var BannerWrapper = withTheming(styled.div.withConfig({
  displayName: "styles__BannerWrapper",
  componentId: "sc-6v1sxf-0"
})(["border-radius:", "px;padding:", "px;", " display:grid;grid-gap:", "px;grid-template-columns:", " 1fr ", ";position:relative;overflow:hidden;& > button{align-self:start;}"], function (props) {
  return getBorderRadiusValue(props);
}, Spacing.Small, function (props) {
  return getColorSet(props);
}, Spacing.Small, function (props) {
  return props.shouldRenderIcon ? 'auto ' : '';
}, function (props) {
  return props.hasCloseButton ? ' auto' : '';
}));
var BannerContentWrapper = styled.div.withConfig({
  displayName: "styles__BannerContentWrapper",
  componentId: "sc-6v1sxf-1"
})(["display:flex;align-items:flex-start;justify-content:flex-start;gap:", "px;flex-flow:row wrap;@media (min-width:", "px){flex-flow:", ";justify-content:", ";}"], Spacing.XxSmall, Breakpoints.Mobile, function (_ref3) {
  var actionPosition = _ref3.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? 'row wrap' : 'row nowrap';
}, function (_ref4) {
  var actionPosition = _ref4.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? 'flex-start' : 'space-between';
});
var BannerContent = styled.div.withConfig({
  displayName: "styles__BannerContent",
  componentId: "sc-6v1sxf-2"
})(["", ""], function (props) {
  return !props.shouldRenderIcon && css(["align-self:center;"]);
});
var BannerActionsWrapper = styled.div.withConfig({
  displayName: "styles__BannerActionsWrapper",
  componentId: "sc-6v1sxf-3"
})(["display:flex;align-items:flex-start;flex-direction:row;flex-wrap:wrap;gap:", "px;flex-basis:100%;@media (min-width:", "px){flex-direction:", ";flex-wrap:", ";flex-basis:", ";justify-content:", ";}& > button{flex-basis:auto;}"], Spacing.XxSmall, Breakpoints.Mobile, function (_ref5) {
  var actionPosition = _ref5.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? 'row' : 'row-reverse';
}, function (_ref6) {
  var actionPosition = _ref6.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? 'wrap' : 'nowrap';
}, function (_ref7) {
  var actionPosition = _ref7.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? '100%' : 'auto';
}, function (_ref8) {
  var actionPosition = _ref8.actionPosition;
  return actionPosition === BannerActionPositions.Bottom ? undefined : 'space-between';
});
var IconContainer = withTheming(styled.div.withConfig({
  displayName: "styles__IconContainer",
  componentId: "sc-6v1sxf-4"
})(["height:", "px;width:", "px;border-radius:50%;background:", ";color:", ";display:flex;align-items:center;justify-content:center;"], function (props) {
  return props.type === BannerType.Subdued ? Spacing.XLarge : Spacing.Large;
}, function (props) {
  return props.type === BannerType.Subdued ? Spacing.XLarge : Spacing.Large;
}, function (props) {
  return props.theme.Colors["Banner".concat(props.variant).concat(props.type, "IconBackground")];
}, function (props) {
  return props.theme.Colors["Banner".concat(props.variant).concat(props.type, "Icon")];
}));

export { BannerActionsWrapper, BannerContent, BannerContentWrapper, BannerWrapper, IconContainer };
